/**
 * Prevents the mouse wheel from incrementing/decrementing a focused
 * `<input type="number">`. Call once at app startup (main.tsx).
 *
 * Without this, scrolling while a number field is focused changes its value
 * and fires onChange — a default browser behavior.
 */
let initialized = false;

export function initPreventNumberInputWheel(): void {
  if (initialized || typeof document === 'undefined') return;
  initialized = true;

  document.addEventListener(
    'wheel',
    (event) => {
      const el = document.activeElement;
      if (el instanceof HTMLInputElement && el.type === 'number') {
        event.preventDefault();
      }
    },
    { passive: false, capture: true }
  );
}
